import { paginated } from '@/store/helpers'

const initialState = {
  page: {
    limit: 30,
    offset: 0
  }
}

const organizationModule = {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    ...paginated.mutations
  },
}

export default organizationModule
export { initialState }
